import { AVATAR_HEIGHT_24 } from '../../../Avatar'
import { ICON_HEIGHT_24 } from '../../../Icon'
import { ListItem } from '../../../ListItem'

import * as styles from './FolderListItem.module.css'

import FolderIcon from '../../../../icons/folder.svg'

function FolderListItem({ item, ref, onClick, ...divProps }) {
  function handleClick() {
    onClick(item)
  }

  return (
    <div {...divProps} ref={ref}>
      <ListItem
        ListIcon={FolderIcon}
        avatarProps={{
          avatarClassName: styles.avatar,
          iconSize: ICON_HEIGHT_24,
          size: AVATAR_HEIGHT_24,
        }}
        isPersistent={item.is_persistent}
        text={item.name}
        onDoubleClick={handleClick}
      />
    </div>
  )
}

export default FolderListItem
